/* istanbul ignore file */

/**
 * Width at which the media gallery stops being a swipe carousel and becomes a grid of tiles,
 * for the consumers that opt in with `allowGridLayout`.
 *
 * It is the width at which the PDP itself becomes two columns (see `PDPLayoutView.styles.ts`,
 * which defines the same value for the same reason: not depending on the deprecated
 * `@noths/polaris-client-ribbons-base` grid). The grid exists because the page has two columns
 * at that point, not because the gallery has more room: the images column measures 407px at
 * this viewport, narrower than the edge-to-edge carousel it replaces, which can be up to 767px.
 * A container query cannot tell those two apart, which is why this is a viewport width.
 *
 * It is read in two places and must stay one value: `ProductMediaCarousel.styles.ts` lays the
 * grid out at this width, and `useIsGridLayout` matches the same query so the two things CSS
 * cannot decide, mounting the video player and which slides are in the tab order, agree with
 * what is actually on screen.
 */
export const GALLERY_GRID_MIN_WIDTH = 768;

/**
 * How many tiles the grid lays out: the hero across both columns, plus two beneath it.
 *
 * It is read in two places and must stay one value: `ProductMediaCarousel.styles.ts` hides the
 * slides past it, and `ProductMediaCarousel` decides from it whether the "View all photos"
 * pill has anything left to reveal.
 */
export const GALLERY_GRID_MAX_TILES = 3;
